const DATE_PART_PADDING = 2

const formatApiDate = (date: Date) => {
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(DATE_PART_PADDING, "0")
	const day = String(date.getDate()).padStart(DATE_PART_PADDING, "0")
	return `${year}-${month}-${day}`
}

export const getThisMonthRange = (now = new Date()): Pick<ICompanyTransactionFilter, "from" | "to"> => ({
	from: formatApiDate(new Date(now.getFullYear(), now.getMonth(), 1)),
	to: formatApiDate(now)
})

export const getLastDaysRange = (days: number, now = new Date()): Pick<ICompanyTransactionFilter, "from" | "to"> => {
	const from = new Date(now)
	from.setDate(from.getDate() - Math.max(0, days - 1))
	return { from: formatApiDate(from), to: formatApiDate(now) }
}

export const getLastMonthsRange = (months: number, now = new Date()): Pick<ICompanyTransactionFilter, "from" | "to"> => {
	const from = new Date(now)
	from.setMonth(from.getMonth() - months)
	return { from: formatApiDate(from), to: formatApiDate(now) }
}

export const getTodayRange = (now = new Date()): Pick<ICompanyTransactionFilter, "from" | "to"> => ({
	from: formatApiDate(now),
	to: formatApiDate(now)
})

export const getYesterdayRange = (now = new Date()): Pick<ICompanyTransactionFilter, "from" | "to"> => {
	const yesterday = new Date(now)
	yesterday.setDate(yesterday.getDate() - 1)
	return { from: formatApiDate(yesterday), to: formatApiDate(yesterday) }
}

export const getThisWeekRange = (now = new Date()): Pick<ICompanyTransactionFilter, "from" | "to"> => {
	const monday = new Date(now)
	const day = monday.getDay()
	monday.setDate(monday.getDate() - (day === 0 ? 6 : day - 1))
	return { from: formatApiDate(monday), to: formatApiDate(now) }
}
